"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assign = void 0;
exports.clear = clear;
exports.getValues = void 0;
exports.isEmpty = isEmpty;

/**
 * @module ol/obj
 */

/**
 * Polyfill for Object.assign().  Assigns enumerable and own properties from
 * one or more source objects to a target object.
 * See https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign.
 *
 * @param {!Object} target The target object.
 * @param {...Object} var_sources The source object(s).
 * @return {!Object} The modified target object.
 */
var assign = typeof Object.assign === 'function' ? Object.assign : function (target, var_sources) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var output = Object(target);

  for (var i = 1, ii = arguments.length; i < ii; ++i) {
    var source = arguments[i];

    if (source !== undefined && source !== null) {
      for (var key in source) {
        if (source.hasOwnProperty(key)) {
          output[key] = source[key];
        }
      }
    }
  }

  return output;
};
/**
 * Removes all properties from an object.
 * @param {Object} object The object to clear.
 */

exports.assign = assign;

function clear(object) {
  for (var property in object) {
    delete object[property];
  }
}
/**
 * Polyfill for Object.values().  Get an array of property values from an object.
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/values
 *
 * @param {!Object<K,V>} object The object from which to get the values.
 * @return {!Array<V>} The property values.
 * @template K,V
 */


var getValues = typeof Object.values === 'function' ? Object.values : function (object) {
  var values = [];

  for (var property in object) {
    values.push(object[property]);
  }

  return values;
};
/**
 * Determine if an object has any properties.
 * @param {Object} object The object to check.
 * @return {boolean} The object is empty.
 */

exports.getValues = getValues;

function isEmpty(object) {
  var property;

  for (property in object) {
    return false;
  }

  return !property;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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